class PromoBarDetails extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.template = this.querySelector("template");

    if (!this.button || !this.template) return;

    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this._open();
    });
  }

  _open() {
    const target = this.getAttribute("target");
    if (!target) return;

    this.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: { target, html: this.template.innerHTML },
      }),
    );
  }
}

if (!customElements.get("promo-bar-details")) {
  customElements.define("promo-bar-details", PromoBarDetails);
}
